import { useMemo } from 'react';

import { useMembershipModalState } from '../../../../modalContext';

type HighlightTextStyles = Readonly<{
	backgroundColor: string;
	selectedBackgroundColor: string;
	borderColor: string;
	selectedBorderColor: string;
	textColor: string;
	selectedTextColor: string;
	iconColor: string;
	selectedIconColor: string;
}>;

type Result = ModelHookResult<HighlightTextStyles, undefined>;

const CONTROL_STYLES = (variant: 'control' | 'variant_1' | 'variant_2'): HighlightTextStyles => ({
	backgroundColor:
		variant === 'control' ? 'sunrise.semantic.fill.weaker' : 'sunrise.semantic.fill.accent.primary.strong',
	selectedBackgroundColor: 'sunrise.semantic.fill.accent.primary.strong',
	borderColor: 'transparent',
	selectedBorderColor: 'sunrise.semantic.fill.accent.primary.weaker',
	textColor:
		variant === 'control' ? 'sunrise.semantic.typography.strong' : 'sunrise.semantic.typography.inverse.strong',
	selectedTextColor: 'sunrise.semantic.typography.inverse.strong',
	iconColor: variant === 'control' ? 'sunrise.semantic.icon.strong' : 'sunrise.semantic.icon.inverse.strong',
	selectedIconColor: 'sunrise.semantic.icon.inverse.strong',
});

const VARIANT_STYLES: HighlightTextStyles = {
	backgroundColor: 'sunrise.semantic.fill.weaker',
	selectedBackgroundColor: 'sunrise.semantic.fill.accent.primary.weaker',
	borderColor: 'transparent',
	selectedBorderColor: 'sunrise.semantic.stroke.inverse.strong',
	textColor: 'sunrise.semantic.typography.strong',
	selectedTextColor: 'sunrise.semantic.typography.accent.primary',
	iconColor: 'sunrise.semantic.icon.strong',
	selectedIconColor: 'sunrise.semantic.icon.accent.primary',
};

export function useHighlightText(): Result {
	const [{ koiPpmuDesignExperimentVariant, revenuePpmuMultiplePricesExpData }] = useMembershipModalState();

	const data = useMemo(() => {
		return koiPpmuDesignExperimentVariant === 'variant_3'
			? VARIANT_STYLES
			: CONTROL_STYLES(revenuePpmuMultiplePricesExpData.variant);
	}, [koiPpmuDesignExperimentVariant, revenuePpmuMultiplePricesExpData.variant]);

	return { data };
}
